import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import FamilyHeader from "./FamilyHeader";
import FamilyClientSelect from "./FamilyClientSelect";
import ContactVerificationPrompt from "../../common/components/ContactVerificationPrompt";
import { CONTACT_VERIFICATION_ROLE, markContactVerificationPromptShown } from "../../common/utils/contactVerification";
import { resolveHomeVerificationPrompt } from "../../common/utils/homeVerificationPrompt";
import { getSessionContext } from "../../common/utils/sessionContext";
import { FaClipboardList, FaHeartbeat } from "react-icons/fa";
import { HiSparkles } from "react-icons/hi2";

const FamilyHome = () => {
  const navigate = useNavigate();
  const { familyMemberName } = getSessionContext();
  const greetingName = familyMemberName?.trim() || "there";
  const [showVerificationPrompt, setShowVerificationPrompt] = useState(false);
  const [verificationPromptMessage, setVerificationPromptMessage] = useState("");

  /*
  useEffect(() => {
    let cancelled = false;

    const loadVerificationPrompt = async () => {
      const result = await resolveHomeVerificationPrompt(CONTACT_VERIFICATION_ROLE.FAMILY);
      if (cancelled || !result.shouldShow) {
        return;
      }

      setVerificationPromptMessage(result.message);
      setShowVerificationPrompt(true);
      markContactVerificationPromptShown(CONTACT_VERIFICATION_ROLE.FAMILY);
    };

    loadVerificationPrompt();
    return () => {
      cancelled = true;
    };
  }, []);

  const handleCloseVerificationPrompt = () => {
    setShowVerificationPrompt(false);
    markContactVerificationPromptShown(CONTACT_VERIFICATION_ROLE.FAMILY);
  };
  */

  const menus = [
    {
      label: "Checklist",
      path: "/family-checklist",
      icon: FaClipboardList,
      description: "Daily care tasks & completion status",
    },
    {
      label: "Vitals",
      path: "/family-vitals",
      icon: FaHeartbeat,
      description: "Blood pressure & health readings",
    },
  ];

  return (
    <div className="family-home-layout">
      <FamilyHeader />
      <main className="family-home-page">
        <section className="family-home-hero">
          <HiSparkles className="family-home-hero-star" aria-hidden="true" />
          <h1 className="family-home-hero-title">Hi, {greetingName}</h1>
          <div className="family-home-hero-copy">
            <p className="family-home-hero-line">Here&apos;s what&apos;s happening with your loved one&apos;s care right now.</p>
          </div>
          <FamilyClientSelect variant="hero" />
          <p className="family-home-hero-line" style={{ marginTop: "10px" }}>
            Choose what you would like to view today.
          </p>
        </section>

        <div className="family-home-cards">
          {menus.map(({ label, path, icon: Icon, description }) => (
            <button key={label} type="button" className="family-home-card" onClick={() => navigate(path)}>
              <span className="family-home-card-icon-wrap">
                <Icon className="family-home-card-icon" aria-hidden="true" />
              </span>
              <span className="family-home-card-body">
                <span className="family-home-card-title">{label}</span>
                <span className="family-home-card-desc">{description}</span>
              </span>
            </button>
          ))}
        </div>
      </main>
      {/*
      <ContactVerificationPrompt
        open={showVerificationPrompt}
        onClose={handleCloseVerificationPrompt}
        role={CONTACT_VERIFICATION_ROLE.FAMILY}
        message={verificationPromptMessage}
      />
      */}
    </div>
  );
};

export default FamilyHome;
